var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"sg-color-blue"},[_c('a',{attrs:{"href":'mailto:' + _vm.email}},[_vm._v(_vm._s(_vm.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }